import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    TextFill,
    tfmixin
} from './vue/components/text-fill/TextFill.vue';
import {
    journalistDetailMixin
} from './vue/mixins/journalist';
import lazyload from './features/lazy-load';

lazyload();

const mixins = [];
mixins.push(tfmixin);
mixins.push(journalistDetailMixin);

initMain(mixins, {
    TextFill,
    JournalistPager: () => import('./vue/components/journalist-pager/JournalistPager.vue'),
    JournalistsAc: () => import('./vue/components/journalists-ac/JournalistsAc.vue'),
    Trends: () => import('./vue/components/trends/Trends.vue')
}, []);

header();